export const AdvanceFilterOptionType = Object.freeze({
  Text: 'text',
  Number: 'number',
  Select: 'select',
  AsyncSelect: 'async_select',
  Date: 'date',
  Phone: 'phone',
  ChipInput: 'chip_input',
})

export const RuleOperator = Object.freeze({
  Equal: 'eq',
  NotEqual: 'neq',
  In: 'in',
  NotIn: 'notin',
  GreatThanEqual: 'gte',
  LessThanEqual: 'lte',
  GreatThan: 'gt',
  LessThan: 'lt',
  Date_Today: 'date_today',
  This_Week: 'this_week',
  This_Month: 'this_month',
})

export const SelectOperatorOptions = [
  {
    value: RuleOperator.Equal,
    label: 'Bằng',
  },
  {
    value: RuleOperator.NotEqual,
    label: 'Không bằng',
  },
]

export const DateOperatorOptions = [
  {
    value: RuleOperator.Equal,
    label: 'Trong ngày',
  },
  {
    value: RuleOperator.GreatThan,
    label: 'Sau ngày',
  },
  {
    value: RuleOperator.LessThan,
    label: 'Trước ngày',
  },
  {
    value: RuleOperator.Date_Today,
    label: 'Hôm nay',
  },
  {
    value: RuleOperator.This_Week,
    label: 'Tuần này',
  },
  {
    value: RuleOperator.This_Month,
    label: 'Tháng này',
  },
]

export const TextOperatorOptions = [
  {
    value: RuleOperator.Equal,
    label: 'Bằng',
  },
  {
    value: RuleOperator.NotEqual,
    label: 'Không bằng',
  },
  {
    value: RuleOperator.In,
    label: 'Có chứa',
  },
  {
    value: RuleOperator.NotIn,
    label: 'Không chứa',
  },
]

export const NumberOperatorOptions = [
  {
    value: RuleOperator.Equal,
    label: 'Bằng',
  },
  {
    value: RuleOperator.GreatThanEqual,
    label: 'Lớn hơn',
  },
  {
    value: RuleOperator.LessThanEqual,
    label: 'Nhỏ hơn',
  },
]
